import React from "react";
import moment from "moment";
import { Table, Row, Col } from "antd";
import ButtonStandard from "../../../../components/utils/button";
import PencilIcon from "../../../../components/utils/icons/pencil";
import TrashIcon from "../../../../components/utils/icons/trash";
import { numberMask } from "../../../../services/helpersMethodsService";

const GENDER_OPTIONS = [
  { value: "V", labelKey: "vaca" },
  { value: "N", labelKey: "novilha" },
  { value: "I", labelKey: "machoInteiro" },
  { value: "C", labelKey: "machoCastrado" },
];

const HerdsTable = ({ data = [], onEdit, onRemove, translation }) => {
  // Calcular total de animais
  const totalAnimals = data.reduce((sum, record) => {
    return sum + (record.amountAnimals || 0);
  }, 0);

  // Calcular média ponderada de peso
  const weightedSum = data.reduce((sum, record) => {
    return sum + ((record.weightAverage || 0) * (record.amountAnimals || 0));
  }, 0);
  const weightedAverage = totalAnimals > 0 ? weightedSum / totalAnimals : 0;

  return (
    <>
      <Table
        rowKey="id"
        dataSource={data}
        pagination={false}
        size="small"
        scroll={{ x: true }}
      >
        <Table.Column
          dataIndex="cjt"
          title={translation.boitelContractsPage.form.herds.cjt}
          align="center"
          width={80}
          render={(_, record, index) => index + 1}
        />
        <Table.Column
          dataIndex="amountAnimals"
          title={translation.boitelContractsPage.form.herds.amountAnimals}
          align="center"
        />
        <Table.Column
          dataIndex="breedName"
          title={translation.boitelContractsPage.form.herds.breed}
          align="center"
        />
        <Table.Column
          dataIndex="gender"
          title={translation.boitelContractsPage.form.herds.gender}
          align="center"
          render={(value) => translation.boitelContractsPage.form.herds.genderOptions[GENDER_OPTIONS.find((opt) => opt.value === value)?.labelKey] || "-"}
        />
        <Table.Column
          dataIndex="weightAverage"
          title={translation.boitelContractsPage.form.herds.weightAverage}
          align="center"
          render={(value) => (value ? numberMask(value, false) : "-")}
        />
        <Table.Column
          dataIndex="useSisbov"
          title={translation.boitelContractsPage.form.herds.useSisbov}
          align="center"
          render={(value) => (value ? "Sim" : "Não")}
        />
        <Table.Column
          dataIndex="trace"
          title={translation.boitelContractsPage.form.herds.trace}
          align="center"
          render={(value) => (value ? "Sim" : "Não")}
        />
        <Table.Column
          dataIndex="entryDate"
          title={translation.boitelContractsPage.form.herds.entryDate}
          align="center"
          render={(date) =>
            date ? moment(date).format("DD/MM/YYYY") : "-"
          }
        />
        <Table.Column
          dataIndex="supplementName"
          title={translation.boitelContractsPage.form.herds.supplement}
          align="center"
          render={(value) => value || "-"}
        />
        <Table.Column
          dataIndex="farmName"
          title={translation.boitelContractsPage.form.herds.farm}
          align="center"
          render={(value) => value || "-"}
        />
        <Table.Column
          dataIndex="actions"
          title=""
          align="center"
          width={100}
          render={(_, record) => (
            <Row type="flex" justify="center" gutter={8}>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                type="button"
                onClick={() => onEdit(record)}
              >
                <PencilIcon />
              </ButtonStandard>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                type="button"
                onClick={() => onRemove(record)}
              >
                <TrashIcon />
              </ButtonStandard>
            </Row>
          )}
        />
      </Table>
      {data.length > 0 && (
        <Row
          type="flex"
          style={{
            marginTop: "8px",
            padding: "12px 16px",
            borderTop: "1px solid #e8e8e8",
            backgroundColor: "#fafafa",
          }}
        >
          <Col span={24}>
            <Row type="flex" justify="start" align="middle" gutter={24}>
              <Col>
                <span style={{ marginRight: "8px" }}>
                  {translation.boitelContractsPage.form.herds.amountAnimals}:
                </span>
                <strong>{totalAnimals}</strong>
              </Col>
              <Col>
                <span style={{ marginRight: "8px" }}>
                  {translation.boitelContractsPage.form.herds.weightAverage}:
                </span>
                <strong>
                  {weightedAverage > 0 ? weightedAverage.toFixed(2) : "-"}
                </strong>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default HerdsTable;

